module.exports = __webpack_public_path__ + "img/HR14036333877.a7ecdf97.png";